import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import apiClient from '../../services/apiClient';

export interface FilterState {
  selectedGame: string;
  selectedLeague: string;
}

const initialState: FilterState = {
  selectedGame: 'PoE1', // Default to Path of Exile 1
  selectedLeague: '', // Will be populated by first available league
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setGame: (state, action: PayloadAction<string>) => {
      state.selectedGame = action.payload;
      apiClient.defaults.params = {
        ...apiClient.defaults.params,
        game: action.payload || undefined,
      };
    },
    setLeague: (state, action: PayloadAction<string>) => {
      console.log(`[FilterSlice] Setting league to: ${action.payload}`);
      state.selectedLeague = action.payload;
      apiClient.defaults.params = {
        ...apiClient.defaults.params,
        league: action.payload || undefined,
      };
    },
    setFilters: (state, action: PayloadAction<{ game: string; league: string }>) => {
      state.selectedGame = action.payload.game;
      state.selectedLeague = action.payload.league;
      apiClient.defaults.params = {
        ...apiClient.defaults.params,
        game: action.payload.game || undefined,
        league: action.payload.league || undefined,
      };
    },
    resetFilters: state => {
      state.selectedGame = initialState.selectedGame;
      state.selectedLeague = initialState.selectedLeague;
      apiClient.defaults.params = {
        ...apiClient.defaults.params,
        game: initialState.selectedGame || undefined,
        league: initialState.selectedLeague || undefined,
      };
    },
  },
});

// Export actions
export const { setGame, setLeague, setFilters, resetFilters } = filterSlice.actions;

// Export selectors
export const selectGameFilter = (state: RootState) => state.filter.selectedGame;
export const selectLeagueFilter = (state: RootState) => state.filter.selectedLeague;
export const selectFilters = (state: RootState) => ({
  game: state.filter.selectedGame,
  league: state.filter.selectedLeague,
});

export default filterSlice.reducer;
